import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { getToken } from '@/utils/auth'
import store from '../store/index'
import {checkAutoLogin} from '@/utils/auth'

Vue.use(VueRouter)

// 解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async(to, _from, next) => {
  // console.log('to',to.path,_from.path)
  var userType = localStorage.getItem('userType') || 'doctor'
  if(getToken()){
    if(localStorage.getItem('expire_time')){
      if(!checkAutoLogin()){
        // 登录过期了
        store.dispatch('loginOut')
      }
    }
    if(userType == 'mf'){
      // 是厂家身份 进医生的页面做限制
      if(!to.meta.isManufacturer){
        next('/manufacturer')
      } else {
        next()
      }
    } else if(userType == 'doctor'){
      // 是医生 进厂家的页面做限制
      if(to.meta.isManufacturer){
        next('/')
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    // 需要登录的页面 在没有登录信息 去首页
    if(to.meta.needLogin){
      next('/')
    } else {
      if(to.meta.isManufacturer){
        // 厂家页面 没登录去首页
        next('/')
      } else {
        next()
      }
    }
  }
})

export default router
